let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9CSBV")).then(() => parcelRequire('3hX8x'));